var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},_vm._l((this.data),function(item){return _c('div',{key:item.id,staticClass:"board"},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":item.icon,"alt":""}})]),_c('div',[_c('span',{staticClass:"value"},[_vm._v(_vm._s(item.value))]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }